import { gql } from '../../hooks'

export const RESET_PASSWORD = gql`
  mutation ResetPassword($password: String!) {
    resetPassword(password: $password) {
    }
  }
`
